<template>
  <div class="border border-gray-200 p-3 mb-4 rounded">

              <div v-show="!showForm">
                <h4 class="inline-block text-2xl font-bold">{{song.modified_name}}</h4>
                <button class="ml-1 py-1 px-2 text-sm rounded text-white bg-red-600 float-right" @click.prevent="deleteSong">
                  <i class="fa fa-times"></i>
                </button>
                <button class="ml-1 py-1 px-2 text-sm rounded text-white bg-blue-600 float-right"
                @click.prevent="showForm=!showForm">
                  <i class="fa fa-pencil-alt "></i>
                </button>
              </div>
              <div v-show="showForm">
                <div class="text-white text-center font-bold p-4 mb-4" v-if="show_alert" :class="alert_variant">
                    {{alert_message}}
                </div>

                <!-- here :initial-values="song means it add exist data in firebase into its corresponding name input" -->
                <vee-form :validation-schema="schema"  :initial-values="song" @submit="edit">
                  <div class="mb-3">
                    <label class="inline-block mb-2">Song Title</label>
                    <vee-field name="modified_name" type="text"
                      class="block w-full py-1.5 px-3 text-gray-800 border border-gray-300
                        transition duration-500 focus:outline-none focus:border-black rounded"
                      placeholder="Enter Song Title" 
                      @input="updateUnsavedFlag(true)"/>
                      <ErrorMessage name="modified_name" class="text-red-600"/>
                  </div>
                  <div class="mb-3">
                    <label class="inline-block mb-2">Genre</label>
                    <vee-field name="genre" type="text"
                      class="block w-full py-1.5 px-3 text-gray-800 border border-gray-300
                        transition duration-500 focus:outline-none focus:border-black rounded"
                      placeholder="Enter Genre" 
                       @input="updateUnsavedFlag(true)"/>
                       <ErrorMessage name="genre" class="text-red-600"/>
                  </div>
                  <button type="submit" class="py-1.5 px-3 rounded text-white bg-green-600"
                  :disabled="in_submission">
                    Submit
                  </button>
                  <button type="button" class="py-1.5 px-3 rounded text-white bg-gray-600"
                  @click.prevent="showForm = false">
                    Go Back
                  </button>
                </vee-form>
              </div>
            </div>
         
</template>

<script>
import {projectFirestore,projectStorage} from '@/firebase/config'
export default {
    name:'compositionitem',
    props: {
        song:{
            type: Object,
            required: true,

        },
        updateUnsavedFlag:{
          type:Function
        },
        
            updateSong:{
                type: Function,
                required:true
            },
            index: {
                type:Number,
                required:true
            },
            removeSong:{
              type:Function,
              required:true
            }

    },
    data(){
        return{
            showForm:false,
            schema:{
                modified_name : 'required',
                genre: 'alpha_spaces'
            },

            in_submission : false,
            show_alert:false,
            alert_variant:"bg-blue-500",
            alert_message: "Please wait!"
        }
        
    },
    methods:{
       async edit(values){
         this.show_alert=true
            this.in_submission=true,
            this.alert_variant='bg-blue-500'
            this. alert_message= "Please wait!"
           try{
                 await projectFirestore.collection('songs').doc(this.song.docId).update(values)

           }
           catch(error){
            this.show_alert=true,
            this.in_submission=false,
            this.alert_variant='bg-red-500',
            this. alert_message= "Error occurs"
            return
           }
           
           this.updateSong(this.index, values)
           this.updateUnsavedFlag(false)
          
           
            this.in_submission=false,
  
            this.alert_variant='bg-green-500'
            this. alert_message= "Success"
          
        },
      async deleteSong(){
        const storageRef = projectStorage.ref()                      // deleting from storage
        const songref = storageRef.child(`songs/${this.song.original_name}`)
        await songref.delete()

        await projectFirestore.collection('songs').doc(this.song.docId).delete()   // delete from firestore
        
        // manage.vue
        this.removeSong(this.index)
        window.location.reload()
      },

    }

   
}
</script>

<style>

</style>